import cn from 'classnames';
import { useLocation } from 'react-router';
import { Link, Text } from 'ui';

const TopBarLink = ({ title, to }: { title: string; to: string }) => {
  const location = useLocation();
  const isSelected = location.pathname === to;

  return (
    <Link className={cn('top-bar-link', { 'top-bar-link--selected': isSelected })} to={to}>
      <Text className={cn('top-bar-link__text', { 'top-bar-link__text--selected': isSelected })} size="large">
        {title}
      </Text>
    </Link>
  );
};

export default TopBarLink;
